// main saga generators
export function* sagas() {
  //yield [];
}



// WEBPACK FOOTER //
// ./src/sagas/index.js